import { Stack, Typography } from '@mui/material';
import {
  FiltersContainer,
  PropertyTypeTagSelect,
  SubjectTagSelect,
} from '@schooly/components/filters';
import { SchoolUserRole } from '@schooly/constants';
import { FC } from 'react';
import { useIntl } from 'react-intl';

import { useSchool } from '../../../../hooks/useSchool';
import { TimetableGridFilters } from '../utils';

type TimetableGridFiltersBarProps = {
  filters: TimetableGridFilters;
  onOpenFilters: () => void;
};

export const TimetableGridFiltersBar: FC<TimetableGridFiltersBarProps> = ({
  filters,
  onOpenFilters,
}) => {
  const { formatMessage } = useIntl();
  const { schoolId } = useSchool();

  if (!schoolId) return null;

  const ageGroupIds = filters.age_group ?? [];
  const subjectIds = filters.subject ?? [];

  return (
    <FiltersContainer onOpenFilters={onOpenFilters}>
      {!!ageGroupIds.length && (
        <FilterGroup label={formatMessage({ id: 'schoolProperty-AgeGroup' })}>
          {ageGroupIds.map((id) => (
            <PropertyTypeTagSelect
              key={id}
              id={id}
              schoolId={schoolId}
              userRole={SchoolUserRole.Student}
              size="small"
              onClick={onOpenFilters}
            />
          ))}
        </FilterGroup>
      )}
      {!!subjectIds.length && (
        <FilterGroup label={formatMessage({ id: 'groups-GroupSubject' })}>
          {subjectIds.map((id) => (
            <SubjectTagSelect
              key={id}
              id={id}
              schoolId={schoolId}
              size="small"
              onClick={onOpenFilters}
            />
          ))}
        </FilterGroup>
      )}
    </FiltersContainer>
  );
};

type FilterGroupProps = {
  label: string;
};

const FilterGroup: FC<React.PropsWithChildren<FilterGroupProps>> = ({ label, children }) => (
  <Stack direction="row" alignItems="center" gap={1}>
    <Typography color="common.grey2">{label}</Typography>
    {children}
  </Stack>
);
